import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} formData
 */
export const AICreatorGetAttachmentService = () =>
  new Request(URL.APP_URL_LLM, URL.GET_ATTACHMENT).get()

/**
 *
 * @param {*} formData
 */
export const AICreatorUploadAttachmentService = formData =>
  new Request(URL.APP_URL_LLM, URL.UPLOAD_ATTACHMENT).post(formData)

/**
 *
 * @param {*} attachmentId
 */
export const AICreatorDeleteAttachmentService = attachmentId =>
  new Request(
    URL.APP_URL_LLM,
    URL.DELETE_ATTACHMENT.replace('{attachmentId}', attachmentId),
  ).delete()

/**
 *
 * @param {*} outline
 */

export const AICreatorUpdateOutlineService = (outline, outlineId) => {
  return new Request(
    URL.APP_URL_LLM,
    URL.UPDATE_OUTLINE.replace('{outlineId}', outlineId),
  ).put(outline)
}

/**
 * @param {*} attachmentId
 *
 */

export const AICreatorCheckAttachmentStatusService = attachmentId => {
  return new Request(
    URL.APP_URL_LLM,
    URL.CHECK_ATTACHMENT_STATUS.replace('{attachmentId}', attachmentId),
  ).get()
}

/**
 * @param {*} attachmentId
 *
 */

export const AICreatorGenerateOutlineService = req => {
  return new Request(URL.APP_URL_LLM, URL.GENERATE_OUTLINE).post({ ...req })
}

/**
 * @param {*} attachmentId
 *
 */

export const AICreatorGenerateCourseService = req => {
  return new Request(URL.APP_URL_LLM, URL.GENERATE_CONTENT).post({ ...req })
}

/**
 * @param {*} attachmentId
 *
 */

export const AICreatorGetDocumentHeadersService = outlineId => {
  return new Request(
    URL.APP_URL_LLM,
    URL.GET_DOCUMENT_HEADERS.replace('{outlineId}', outlineId),
  ).get()
}

/**
 * @param {*} attachmentIds
 *
 */
// attachmentIds is an array of attachment ids

export const AICreatorGetAttachmentTitlesService = attachmentIds => {
  return new Request(URL.APP_URL_LLM, URL.GET_ATTACHMENT_TITLES).post({
    attachmentIds: attachmentIds,
  })
}

export const AICreatorAddAttachmentUrlService = data => {
  return new Request(URL.APP_URL_LLM, URL.ADD_ATTACHMENT_URL).post(data)
}

